module.exports = __webpack_public_path__ + "index-bg-m.png?04da76222e100c88fc4d0c98ab4f36e2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index-bg-m.png
// module id = 41
// module chunks = 0